import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Modal,
  TextField,
  Typography,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 2
};
const TagModal = (props) => {
    const { open, setOpen, setCustomFields, view, current, data } = props;
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");
  
    const handleClose = () => {
      setOpen(false);
      setInputValue("");
    };

    useEffect(() => {
     if(data?.length) {
        setTags(data)
     }
    }, [data])
  
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && inputValue.trim()) {
        e.preventDefault();
        setTags((prev) => [...prev, inputValue.trim()]);
        setInputValue("");
      }
    };
  
    const handleDelete = (indexToRemove) => {
      setTags((prev) => prev.filter((_, i) => i !== indexToRemove));
    };
  
    const handleSave = () => {
      setCustomFields((prev) => {
        const updatedFields = [...(prev[view] || [])];
        updatedFields[current] = {
          ...updatedFields[current],
          values: { values: tags }
        };
        return {
          ...prev,
          [view]: updatedFields
        };
      });
      setTags([])
  
      handleClose();
    };
  
    return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontSize={20} fontWeight={600}>Enter Tags</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon  sx ={{cursor:"pointer"}}/>
            </IconButton>
          </Box>
  
          <Box display="flex" flexWrap="wrap" gap={1}>
            {tags.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                onDelete={() => handleDelete(index)}
                color="primary"
              />
            ))}
          </Box>
  
          <TextField
            fullWidth
            label="Type and press Enter"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            margin="normal"
          />
  
          <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>Save</Button>
          </Box>
        </Box>
      </Modal>
    );
  };

  export default TagModal;
  